export default {
    livechat: {
        allowEmptyTypingEvent: false,
        appEventConstants: {
            liveChatCustomerEnded: {
                name: "LiveChatCustomerEnded",
            },
            liveChatDisconnected: {
                name: "LiveChatDisconnected",
            },
            liveChatOperatorEnded: {
                name: "LiveChatOperatorEnded",
            },
        },
        connectionStatus: {
            connected: "Connected",
            disconnected: "Disconnected",
            disconnecting: "Disconnecting",
            inQueue: "InQueue",
            inQueuePending: "InQueuePending",
        },
        defaultOperatorName: "Agent",
        shouldDisplayTimestamp: false,
        endChatSource: {
            operator: "operator",
            user: "user",
        },
        error: {
            maxErrorCountAllowed: 5,
        },
        liveChatStartAction: 'LiveChatStart',
        maxInputLength: 1000,
        messageOrigin: {
            operator: 'Operator',
            operatorJoined: 'Operator-Joined',
            operatorLeft: 'Operator-Left',
            operatorTyping: 'Operator-Typing',
            sessionEnd: 'Session-End',
            system: 'System',
            user: 'User',
        },
        messagePollingInterval: 2000,
        messageSource: 'LiveChat',
        messageSourceConstants: {
            beginChat: "BeginLiveChat",
            chatEvent: "ChatEvent",
            getChatStatus: "GetChatState",
            getNotifications: "LiveChatGetNotification",
            getMessages: "GetMessages",
            sendMessage: "SendMessage",
            userEndChat: "UserEndChat",
        },
        openResponseLinksInNewWindow: true,
        pollInterval: {
            active: {
                backoffSequence: "linear",
                difference: 500,
                maxMs: 3e3,
                ratio: 1.2,
                startMs: 500,
            },
            standby: {
                backoffSequence: "exponential",
                difference: 1e3,
                maxMs: 10e3,
                ratio: 1.1,
                startMs: 2e3,
            },
        },
        reportingEventConstants: {
            terminateSessionEventName: 'TerminateSession',
            userTypingEventName: 'Typing',
        },
        responseActionConstants: {
            beginChat: {
                name: "BeginLiveChat",
            },
            operatorConnected: {
                name: "ConnectOperator",
            },
            operatorDisconnected: {
                name: "DisconnectOperator",
            },
            userDisconnected: {
                name: "EndLiveChat",
            },
        },
        SendMessageExtStaging: {
            Base: "SendMessageExtStaging",
            ReceivedResponse: "ReceivedResponse",
        },
        sessionEndReason: {
            agent: 'Agent',
            error: 'Error',
            notEngaged: 'NotEngaged',
            user: 'User',
        },
        sessionState: {
            offline: 'Offline',
            online: 'Online',
            queued: 'Queued',
        },
        textConstants: {
            //header
            bannerText: 'Live Chat',

            //connect/disconnect banner
            chatBannerConnectedAdditional: "",
            chatBannerConnectedPrimary: "Connected to",
            chatBannerConnectedSecondary: "Customer Service Representative: {0}",
            chatBannerConnectingAdditional: "",
            chatBannerConnectingPrimary: "Connecting to",
            chatBannerConnectingSecondary: "Customer Service Representative",
            chatBannerNotEngagedDisconnectAdditional: 'System Ended Live Chat',
            chatBannerNotEngagedDisconnectPrimary: 'Returning to',
            chatBannerNotEngagedDisconnectSecondary: 'Intelligent Virtual Assistant',
            chatBannerOperatorDisconnectAdditional: 'Agent Ended Live Chat',
            chatBannerOperatorDisconnectPrimary: 'Returning to',
            chatBannerOperatorDisconnectSecondary: 'Intelligent Virtual Assistant',
            chatBannerOperatorDisconnectedAdditional: "Operator Ended Live Chat",
            chatBannerOperatorDisconnectedPrimary: "Returning to",
            chatBannerOperatorDisconnectedSecondary: "Iva",
            chatBannerSystemDisconnectAdditional: 'System Ended Live Chat',
            chatBannerSystemDisconnectPrimary: 'Returning to',
            chatBannerSystemDisconnectSecondary: 'Intelligent Virtual Assistant',
            chatBannerSystemDisconnectedAdditional: "System Ended Live Chat",
            chatBannerSystemDisconnectedPrimary: "Returning to",
            chatBannerSystemDisconnectedSecondary: "Iva",
            chatBannerUserDisconnectAdditional: 'Customer Ended Live Chat',
            chatBannerUserDisconnectPrimary: 'Returning to',
            chatBannerUserDisconnectSecondary: 'Intelligent Virtual Assistant',
            chatBannerUserDisconnectedAdditional: "Customer Ended Live Chat",
            chatBannerUserDisconnectedPrimary: "Returning to",
            chatBannerUserDisconnectedSecondary: "Iva",

            //end chat link
            endChatLinkText: "End Live Chat",
            endChatLinkToolTip: "Click to end Live Chat",

            //ui error response
            errorResponse: 'Uh oh, looks like we were unable to process your request. Please try again.',

            //input box
            pendingPlaceholder: 'Please wait...',

            //response constants
            responseTitleText: "{0} said:",

            //typing notification
            typingNotificationText: '{0} typing...',
        },
        timeouts: {
            operatorTypingDelayMS: 3000,
            typingStateTransitionInterval: 2500,
        },
        userTypingTimeoutMS: 2000,
        waitingMessageRotationTime: 500,
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/livechat.ts